import { IBetPosition } from '../../../../../redux/reducers';

export const getLeadBetPositionText = ({ page, offerPosition }: IBetPosition): string => {
  return `${page} страница, ${offerPosition} место`;
};
